module.exports = __webpack_public_path__ + "static/img/logo1.7543d15.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/logo1.png
// module id = FlzO
// module chunks = 66